import PropTypes from 'prop-types';
import { createContext, useContext, useMemo } from 'react';
import { UserListContext } from './UserListContext';

const CertificationUsersContext = createContext({
  certificationUsers: [],
  certificationUsersById: {},
  certificationUsersByUsername: {},
  isLoadingCertificationUsers: false,
});

const CertificationUsersContextProvider = ({ children }) => {
  const { users, isLoadingUsers } = useContext(UserListContext);

  // Filter users who have the 'view_earned_certifications' role
  const certificationUsers = useMemo(() => {
    const filtered = users.filter(
      (u) => u.roles && u.roles.includes('view_earned_certifications')
    );
    return filtered.sort((a, b) =>
      (a.full_name || '').localeCompare(b.full_name || '')
    );
  }, [users]);

  const certificationUsersById = useMemo(
    () =>
      Object.freeze(
        Object.fromEntries(certificationUsers.map((user) => [user.id, user]))
      ),
    [certificationUsers]
  );

  const certificationUsersByUsername = useMemo(
    () =>
      Object.freeze(
        Object.fromEntries(
          certificationUsers.map((user) => [user.username, user])
        )
      ),
    [certificationUsers]
  );

  return (
    <CertificationUsersContext.Provider
      value={{
        certificationUsers,
        certificationUsersById,
        certificationUsersByUsername,
        isLoadingCertificationUsers: isLoadingUsers,
      }}
    >
      {children}
    </CertificationUsersContext.Provider>
  );
};

CertificationUsersContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { CertificationUsersContext, CertificationUsersContextProvider };
